module.exports = (SalonService, RESTService) ->
  'ngInject'
  {
    service: (salonId) ->
      RESTService.service('refund_policies', SalonService.one(salonId))
  }
